<template>
  <div class="app-modal-galery">
    <div class="overlay-full cursorp" @click="hidePicture()" title="Klicken zum Ausblenden">
      <div class="d-flex align-items-center flex-column justify-content-center text-white" id="header">
        <div class="picPlaceholder">
          <img v-if="selectedPicture" title="" @click.stop="dummyClick()" :src="require(`@/assets/img/${picFolder}${selectedPicture}`)" class="prev-pic" alt=""/>
          <div v-if="selPicIndex!==0" class="btn-change-pic" :title="$t('prev')" @click.stop="changePicture(-1)" style="left:-60px;">
            <img src="@/assets/img/Arrow_Slider_Left.png" style=""/>
          </div>
          <div><i class="fas fa-times"></i></div>
          <div v-if="selPicIndex!==pictures.length-1" class="btn-change-pic" :title="$t('next')" @click.stop="changePicture(1)" style="right:-60px;">
            <img src="@/assets/img/Arrow_Slider_Right.png" style=""/>
          </div>
        </div>
        <div v-if="copyright!==''" class="copyright w-100 text-center" v-html="copyright">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AppModalGalery",
  props: {
    picFolder: {
      type: String,
      default: 'GeraInside/'
    },
    pictures: null,
    startPictureIndex: {
      type: Number,
      default: 0
    },
    width: {
      type: String,
      default: "auto"
    },
    copyright: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
    	story: this.$store.state.story,
      overlayVisible: false,
      selectedPicture: null,
      selPicIndex: this.startPictureIndex
    }
  },
  mounted(){
    this.selectedPicture = this.pictures[this.startPictureIndex]
  },
  methods: {
    dummyClick(){
      // dummy Click
    },
    changePicture(where){
      this.selPicIndex = this.selPicIndex + where;
      this.selectedPicture = this.pictures[this.selPicIndex];
    },
    hidePicture(){
      this.$emit('closePicGalery');
    }
  }
};
</script>
<style lang="scss" scoped>
  #header {
    margin-top:15vh !important;
    height:70vh !important;
  }
  .picPlaceholder {
    width:auto;height:auto;position:relative;
  }
  .picPlaceholder img {
    max-width:90vw;max-height:90vh;cursor:default;border:solid 2px #ccc;
  }
  .btn-change-pic {
    position:absolute;top:0;width:60px;height:97.5%;right:-60px;max-height:90vh;
  }
  .btn-change-pic img {
    position:absolute; margin:0; top: 50%;-ms-transform: translateY(-50%);transform: translateY(-50%); left:-5px; border:none; cursor:pointer;
  }
</style>
<i18n>
	{
		"de": {
			"prev": "vorheriges Bild",
			"next": "nächstes Bild"
		},
		"en": {
			"prev": "previous picture",
			"next": "next picture"
		}
	}
</i18n>
